import { render, staticRenderFns } from "./FarbkarteModal.vue?vue&type=template&id=3806298a&scoped=true&"
import script from "./FarbkarteModal.vue?vue&type=script&lang=js&"
export * from "./FarbkarteModal.vue?vue&type=script&lang=js&"
import style0 from "./FarbkarteModal.vue?vue&type=style&index=0&id=3806298a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3806298a",
  null
  
)

export default component.exports